module.exports = __webpack_public_path__ + "img/audi4.3d02ece1.jpg";